<template>
  <tr v-if="result" class="result row">
    <td class="col-12 col-md-4">
      <h3 class="h6" v-if="name" style="font-weight: 600">
        <div>{{ name }}</div>
        <div v-if="result.name2">{{ result.name2 }}</div>
      </h3>
      <address>
      <div class="mb-2">{{ address }}</div>
      <div v-if="bezirk" class="mb-2">
        <strong>Bezirk:&nbsp;</strong>{{ bezirk }}
      </div>
      
      <div v-if="telnr"><strong>Tel.:&nbsp;</strong>{{ telnr }}</div>
      </address>
    </td>
    <td class="text-red col-12 col-md-4" :aria-label="notdiensteAriaLabel">
      <div v-for="dienst in notdienste" class="mb-2 text-red">{{ dienst }}</div>
      <div class="mt-5 text-red text-center-bttm">
        <strong>Notdienst 24 h // 9.00 - 9.00 Uhr</strong>
      </div>
    </td>
    <td class="col-12 col-md-4" :aria-label="standortAriaLabel">
      <div class="mb-2">
        <a :href="gmapsLink" target="_blank"
          ><i class="fas fa-map-marked-alt"></i>&nbsp;Standort <span class="sr-only"> für {{ name }}</span> bei Google
          Maps</a
        >
      </div>
      <div class="mb-2">
        <a :href="bvgLink" target="_blank"
          ><i class="fas fa-train"></i>&nbsp;BVG Verbindungssuche<span class="sr-only"> für {{ name }}</span></a
        >
      </div>
    </td>
  </tr>
</template>

<script setup>
import { defineProps } from "vue";
import { useDataStore } from "@/store/";

const dataStore = useDataStore();
const { result, index } = defineProps({
  result: Object,
  index: Number
});

const typeUp = dataStore.otherInfo.apothekenfinder.type;
let name = result?.name1 ? result?.name1 : result?.name;
name = htmlDecode(name);

if (typeUp == "apotheken") {
  const { street, zip, city } = result;
} else {
  const { street: strasse, zip: plz, city: ort } = result;
}

let address =
  typeUp == "apotheken"
    ? `${result.street}, ${result.zip} ${result.city}`
    : `${result.strasse}, ${result.plz} ${result.ort}`;
address = htmlDecode(address);

const notdienste = result.next_notdienste.map((dienstDate) => {
  const splitDate = dienstDate.split(".");
  const dateOb = new Date(splitDate[2], splitDate[1] - 1, splitDate[0]);
  const dayOfWeek = new Intl.DateTimeFormat("de-DE", {
    weekday: "long",
  }).format(dateOb);
  return `${dayOfWeek}, ${dienstDate}`;
});

const optionsUp = typeof options !== 'undefined' ? options : '{"bezirke":[{"code":"-1","value":"Alle Bezirke"},{"code":"7","value":"Charlottenburg"},{"code":"5","value":"Friedrichshain"},{"code":"23","value":"Hellersdorf"},{"code":"22","value":"Hohensch\u00f6nhausen"},{"code":"6","value":"Kreuzberg"},{"code":"16","value":"K\u00f6penick"},{"code":"17","value":"Lichtenberg"},{"code":"21","value":"Marzahn"},{"code":"1","value":"Mitte"},{"code":"14","value":"Neuk\u00f6lln"},{"code":"19","value":"Pankow"},{"code":"4","value":"Prenzlauer Berg"},{"code":"20","value":"Reinickendorf"},{"code":"11","value":"Sch\u00f6neberg"},{"code":"8","value":"Spandau"},{"code":"12","value":"Steglitz"},{"code":"13","value":"Tempelhof"},{"code":"2","value":"Tiergarten"},{"code":"15","value":"Treptow"},{"code":"3","value":"Wedding"},{"code":"18","value":"Wei\u00dfensee"},{"code":"9","value":"Wilmersdorf"},{"code":"10","value":"Zehlendorf"},{"code":"99","value":"au\u00dferhalb Berlin"}]}';

const { bezirke } = JSON.parse(optionsUp);
const bezirk = bezirke.filter(
  (bezirkUp) => bezirkUp.code == result.bezirkkey
)[0]?.value;

const telnr = result.telnr ?? result.phone_number ?? false;

const gmapsLink =
  "https://www.google.com/maps/search/?api=1&query=" +
  encodeURI(`${name}, ${address}`);

const bvgAddress =
  typeUp == "apotheken"
    ? `${result.zip},${result.city},${result.street}`
    : `${result.plz},${result.ort},${result.strasse}`;
const bvgLink =
  "https://www.bvg.de/de/verbindungen/verbindungssuche?SID=A=1@&ZID=A=2@O=" +
  encodeURI(bvgAddress);

  const notdiensteAriaLabel = "Notdienste für " + name;
  const standortAriaLabel = "Standortinformationen für" + name;
 const ariaName = `Ergebnis ${index + 1} von ${dataStore?.data?.num_items}: ${name}`;

  function htmlDecode(str) {
    const doc = new DOMParser().parseFromString(str, "text/html");
    return doc.documentElement.textContent;
}
</script>
